/* eslint-disable @next/next/no-sync-scripts */

'use client';

import { ConsentGate } from '@hc-frontend/features-data-consent';

function HubSpotPixelInternal() {
  return (
    <script
      id="hs-script-loader"
      type="text/partytown"
      src="https://js.hs-scripts.com/49022532.js"
    />
  );
}

/**
 * HubSpot tracking pixel
 * Gated by consent - only loads if user accepts all cookies
 */
export function HubSpotPixel() {
  return (
    <ConsentGate>
      <HubSpotPixelInternal />
    </ConsentGate>
  );
}
